import { p as proxyCustomElement, H, h } from './p-ae815584.js';
import { h as hasNamedSlot, b as bem } from './p-c44c2366.js';
import { d as defineCustomElement$4 } from './p-705c182a.js';
import { d as defineCustomElement$3 } from './p-4ffb28d0.js';
import { d as defineCustomElement$2 } from './p-db87170c.js';

const cosmosProductItemCss = ".cosmos-product-item{--cosmos-asset-item-base-gap:var(--cosmos-product-item-gap);--cosmos-asset-item-base-headline-color:var(--cosmos-product-item-name-color);--cosmos-asset-item-base-headline-font-family:var(--cosmos-product-item-name-font-family);--cosmos-asset-item-base-headline-font-size:var(--cosmos-product-item-name-font-size);--cosmos-asset-item-base-headline-font-style:var(--cosmos-product-item-name-font-style);--cosmos-asset-item-base-headline-font-weight:var(--cosmos-product-item-name-font-weight);--cosmos-asset-item-base-headline-letter-spacing:var(--cosmos-product-item-name-letter-spacing);--cosmos-asset-item-base-headline-line-height:var(--cosmos-product-item-name-line-height);--cosmos-asset-item-base-headline-text-transform:var(--cosmos-product-item-name-text-transform);--cosmos-asset-item-base-meta-text-primary-color:var(--cosmos-product-item-text-color);--cosmos-asset-item-base-meta-text-primary-font-family:var(--cosmos-product-item-text-font-family);--cosmos-asset-item-base-meta-text-primary-font-size:var(--cosmos-product-item-text-font-size);--cosmos-asset-item-base-meta-text-primary-font-style:var(--cosmos-product-item-text-font-style);--cosmos-asset-item-base-meta-text-primary-font-weight:var(--cosmos-product-item-text-font-weight);--cosmos-asset-item-base-meta-text-primary-letter-spacing:var(--cosmos-product-item-text-letter-spacing);--cosmos-asset-item-base-meta-text-primary-line-height:var(--cosmos-product-item-text-line-height);--cosmos-asset-item-base-meta-text-primary-text-transform:var(--cosmos-product-item-text-text-transform);--cosmos-asset-item-base-meta-text-additional-color:var(--cosmos-product-item-additional-info-color);--cosmos-asset-item-base-meta-text-additional-font-family:var(--cosmos-product-item-additional-info-font-family);--cosmos-asset-item-base-meta-text-additional-font-size:var(--cosmos-product-item-additional-info-font-size);--cosmos-asset-item-base-meta-text-additional-font-style:var(--cosmos-product-item-additional-info-font-style);--cosmos-asset-item-base-meta-text-additional-font-weight:var(--cosmos-product-item-additional-info-font-weight);--cosmos-asset-item-base-meta-text-additional-letter-spacing:var(--cosmos-product-item-additional-info-letter-spacing);--cosmos-asset-item-base-meta-text-additional-line-height:var(--cosmos-product-item-additional-info-line-height);--cosmos-asset-item-base-meta-text-additional-text-transform:var(--cosmos-product-item-additional-info-text-transform)}.cosmos-product-item__image{--cosmos-image-border-radius:var(--cosmos-product-item-image-radius, 4px);height:100%}.cosmos-product-item__additional-info{display:-ms-flexbox;display:flex}.cosmos-product-item__additional-info ::slotted([slot=additional-info-prefix]){-webkit-margin-end:4px;margin-inline-end:4px}";
const CosmosProductItemStyle0 = cosmosProductItemCss;

const generateClassNames = bem('cosmos-product-item');
const CosmosProductItem$1 = /*@__PURE__*/ proxyCustomElement(class CosmosProductItem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleAdditionalInfoPrefixSlotChange = () => {
            this.hasAdditionalInfoPrefixSlot = hasNamedSlot(this.element, 'additional-info-prefix');
        };
        this.additionalInfo = undefined;
        this.appearance = undefined;
        this.href = undefined;
        this.image = undefined;
        this.name = undefined;
        this.rel = undefined;
        this.size = 'small';
        this.target = undefined;
        this.text = undefined;
        this.hasAdditionalInfoPrefixSlot = false;
    }
    getImageAppearance() {
        return this.appearance ? (this.appearance === 'dark' ? 'light' : 'dark') : undefined;
    }
    render() {
        return (h("cosmos-asset-item-base", { key: 'a6b836cc8f4c4c69b97b50b11c270d8727975db5', appearance: this.appearance, class: generateClassNames(), exportparts: "base: base, headline: name,  meta-text-primary: text, additional-info: additional-info", hasAdditionalInfoPrefix: this.hasAdditionalInfoPrefixSlot, headline: this.name, headlineClamp: 2, href: this.href, metaTextAdditional: this.additionalInfo, metaTextPrimary: this.text, metaTextPrimaryClamp: true, rel: this.rel, size: this.size, target: this.target }, h("cosmos-image", { key: '8f64b29fbf53b64c6d2ea4f23b8b2df6eee06e94', appearance: this.getImageAppearance(), class: generateClassNames('image'), exportparts: "base: image", fit: "contain", image: this.image, slot: "image" }), h("div", { key: '6bbbdcbeba7d6366a6746a35675855784b7dcfbb', "aria-hidden": "true", slot: "meta-text-additional-info-prefix", class: generateClassNames('additional-info') }, h("slot", { key: 'cfb1cb266a6aeaa07d9ba23de8694770b0f81b89', name: "additional-info-prefix", onSlotchange: this.handleAdditionalInfoPrefixSlotChange }))));
    }
    get element() { return this; }
    static get style() { return CosmosProductItemStyle0; }
}, [1, "cosmos-product-item", {
        "additionalInfo": [513, "additional-info"],
        "appearance": [513],
        "href": [513],
        "image": [513],
        "name": [513],
        "rel": [513],
        "size": [513],
        "target": [513],
        "text": [513],
        "hasAdditionalInfoPrefixSlot": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-product-item", "cosmos-asset-item-base", "cosmos-image", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-product-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosProductItem$1);
            }
            break;
        case "cosmos-asset-item-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-image":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosProductItem = CosmosProductItem$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosProductItem, defineCustomElement };
